<template src="./index.html">
</template>
<script>
import {
  jxzc_summaryShow_api,
  jxzc_initDownData_api
} from '../../../../../api/iinvout.js'
import minhead from '../../../../common/minHead/index.vue'
import {getdata} from'./data.js'
export default {
  name: '',
  components: {
	  minhead
  },
  props:{
    initdata: {
      type: Object,
      default: () => ({})
    }
  },
  data: function() {
    return {
		headData:getdata().headData,
    tableData:getdata().tableData,
    searchData:this.initdata,
    nsrsbhData:getdata().nsrsbhData
    };
  },
  created() {
    this.init();
  },
  methods: {
	  forback(){
		  this.$emit("closehzck",true)
	  },
    init(){
      jxzc_initDownData_api({}).then(res=>{
        if ( res.data.code != 1 ){
          this.$message.error("初始化数据异常")
        } else {
          this.nsrsbhData = res.data.data.nsrsbhList;
          this.getHzckInfo();
        }
      })
    },
    //获取汇总查看信息
    getHzckInfo(){
      let param = {
        nsrsbh:this.searchData.nsrsbh,
        suosrq:this.searchData.suosq
      }
      jxzc_summaryShow_api(param).then(res => {
        if (res.data.code == 1){
          this.tableData = res.data.data;
        }
      })
    }
  }
};
</script>


<style scoped lang="less">
@import url('./index.less');
</style>
